import { InsightsViewValueRow } from 'contextProviders/InsightsContentProvider/viewTypes';

import isSameRowLabel from './isSameRowLabel';

// Re-attaches rows the head/tail sample dropped when the user has pointed at
// them ("Explain this value"). The clicked row is usually mid-table — exactly
// the region sampling discards — and without it the agent would be asked to
// explain a figure it was never shown. Labels match per isSameRowLabel (a trend
// row's raw date against the clicked bucket's ISO start); a row is appended at
// most once and only when missing, so an already-sampled row is never duplicated.
const pinRows = ({
  sampled,
  all,
  pinnedLabels,
}: {
  sampled: InsightsViewValueRow[];
  all: InsightsViewValueRow[];
  pinnedLabels?: string[];
}): InsightsViewValueRow[] => {
  if (!pinnedLabels || pinnedLabels.length === 0) {
    return sampled;
  }
  const present = [...sampled];
  const pinned: InsightsViewValueRow[] = [];
  pinnedLabels.forEach((label) => {
    const matches = (row: InsightsViewValueRow) =>
      isSameRowLabel({ rowLabel: row.label, label });
    if (present.some(matches)) {
      return;
    }
    const match = all.find(matches);
    if (match) {
      present.push(match);
      pinned.push(match);
    }
  });
  return pinned.length ? [...sampled, ...pinned] : sampled;
};

export default pinRows;
